<template>
  <div
    class="crew-edit flex w-full justify-start"
    style="flex-direction: column;"
  >
    <div ref="crewEditForm" style="margin: 0 1rem;">
      <div style="margin: 1rem 0;" class="required aisea-text-16-400-black">
        必要事項を入力してください。「<label></label>」は入力必須項目です。
      </div>

      <div v-if="inputParam.id">
        <!-- ポップアップ型ではなく、アコーディオンで埋め込む -->
        <vs-collapse accordion style="padding: 0;" ref="avatarCollapse">
          <vs-collapse-item open not-arrow>
            <!-- プロフィール画像 -->
            <div
              slot="header"
              id="collapse-header-avatar-area"
              style="width: 100%; padding: 0; height: 0;"
            ></div>
            <div style="position: relative;">
              <vs-avatar
                :src="avatar"
                :text="avatarText"
                :color="AISEA_COLOR.BLUE"
                class="flex-shrink-0 mr-2"
                size="64px"
                icon="person_add_alt"
                @click="toggleCollapse"
                style="margin-top: 1rem;"
              />
              <div
                style="font-size: xx-small; position: absolute; bottom: 12px; left: 26px; "
                :style="{ color: AISEA_COLOR.WHITE }"
              >
                {{ avatar ? "編集" : "登録" }}
              </div>
            </div>
          </vs-collapse-item>

          <vs-collapse-item not-arrow>
            <!-- プロフィール画像を変更する -->
            <div
              slot="header"
              id="collapse-header-work-area"
              style="width: 100%; padding: 0; height: 0;"
            ></div>
            <div class="flex w-full justify-center">
              <!-- enterprise_crew_id を渡す必要があるので、新規では不可能 -->
              <embedded-upload-profile-image
                class="w-4/5"
                ref="dialogUploadProfileImage"
                :enterpriseCrewId="inputParam.id"
                @onImageUploaded="onImageUploaded"
                @onImageUploadCancel="onImageUploadCancel"
              ></embedded-upload-profile-image>
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="w-full required">
          <vs-input
            class="w-full"
            label="氏名"
            v-model="localData.name"
            v-validate="'required|regex:^[^\x20\u3000].*[^\x20\u3000]$|max:56'"
            name="name"
            data-vv-as="氏名"
            :color="AISEA_COLOR.BLUE"
          />
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem;"
            v-show="errors.has('name')"
            >{{ errors.first("name") }}</span
          >
        </div>
      </div>
      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="w-full required">
          <vs-input
            class="w-full"
            label="氏名(カナ)"
            v-model="localData.name_kana"
            v-validate="'required|regex:^[\u30A1-\u30FF\x20\u3000]+$|max:56'"
            name="name_kana"
            data-vv-as="氏名(カナ)"
            :color="AISEA_COLOR.BLUE"
          />
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem;"
            v-show="errors.has('name_kana')"
            >{{ errors.first("name_kana") }}</span
          >
        </div>
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="w-full" style="position:relative;">
          <label class="vs-input--label">生年月日</label>
          <div
            style="position:absolute; top: 2.2rem; left: 0.8rem; z-index: 9; "
          >
            <vs-icon icon="calendar_today" size="15px" />
          </div>
          <datepicker
            name="birth_date"
            :language="ja"
            :format="formatter"
            :typeable="false"
            placeholder=""
            v-model="localData.birth_date"
            v-validate=""
            data-vv-as="生年月日"
            :disabled-dates="disabledDates"
            ref="datePickerBirthDate"
          ></datepicker>
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem;"
            v-show="errors.has('birth_date')"
            >{{ errors.first("birth_date") }}</span
          >
        </div>
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="flex w-full justify-start items-center">
          <vs-input
            class="w-full"
            label="電話番号"
            v-model="localData.phone_number"
            v-validate="'numeric|custom_phoneNumber'"
            name="phone_number"
            data-vv-as="電話番号"
            :color="AISEA_COLOR.BLUE"
          />
        </div>
        <span
          class="text-danger text-sm"
          style="margin-left: 0.6rem;"
          v-show="errors.has('phone_number')"
          >{{ errors.first("phone_number") }}</span
        >
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <vs-input
          class="w-full"
          :label="
            fromPage === 'CrewProfile'
              ? 'メールアドレス(ユーザーID)'
              : 'メールアドレス'
          "
          v-model="localData.email_address"
          v-validate="'email|max:128'"
          name="email_address"
          data-vv-as="メールアドレス"
          :color="AISEA_COLOR.BLUE"
        />
        <span
          class="text-danger text-sm"
          style="margin-left: 0.6rem;"
          v-show="errors.has('email_address')"
          >{{ errors.first("email_address") }}</span
        >
        <span
          v-if="fromPage === 'CrewProfile'"
          class="aisea-text-12-400-dark-gray"
        >
          ※
          アプリアカウントのユーザーIDとなります。アプリを利用する場合入力して下さい。
        </span>
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="w-full">
          <vs-input
            class="w-full"
            label="社員番号"
            v-model="localData.employee_number"
            v-validate="'max:56'"
            name="employee_number"
            data-vv-as="社員番号"
            :color="AISEA_COLOR.BLUE"
          />
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem;"
            v-show="errors.has('employee_number')"
            >{{ errors.first("employee_number") }}</span
          >
        </div>
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="w-full">
          <affiliated-company-input
            label="社員区分 / 所属企業"
            :is-required="true"
            v-model="localData.affiliated_companies"
            :error-message="getAffiliatedCompaniesError()"
          />
        </div>
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="flex w-full" style="flex-direction: column;">
          <div>
            <label class="vs-input--label">組合員該当有無</label>
            <v-select
              placeholder="組合員該当有無を選択してください"
              class="w-full"
              label="label"
              name="union_member"
              :options="['組合員', '-']"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="localData.union_member"
              v-validate=""
              data-vv-as="組合員該当有無"
              :color="AISEA_COLOR.BLUE"
            >
              <template v-slot:no-options
                >組合員該当有無が見つかりません</template
              >
            </v-select>
            <span
              class="text-danger text-sm"
              style="margin-left: 0.6rem;"
              v-show="errors.has('union_member')"
              >{{ errors.first("union_member") }}</span
            >
          </div>
          <div style="margin-left: 0.6rem;"></div>
        </div>
      </div>
    </div>

    <vs-divider style="margin: 0;" />

    <div class="flex w-full justify-end items-center">
      <div class="w-1/3 flex justify-start items-center" v-if="!inputParam.id">
        <vs-checkbox v-model="continueFlg" :color="AISEA_COLOR.BLUE" /><span
          style="font-size: smaller;"
          >続けて登録する</span
        >
      </div>
      <div class="w-2/3 flex justify-end items-center">
        <div style="margin: 0.8rem;">
          <vs-button
            type="flat"
            style="width: 6rem; padding: 0.4rem;"
            :style="{ 'background-color': AISEA_COLOR.WHITE }"
            @click="onCancel"
            :color="AISEA_COLOR.GRAY"
            >キャンセル</vs-button
          >
        </div>
        <div style="margin: 0.8rem;">
          <vs-button
            style="width: 6rem; padding: 0.4rem;"
            @click="onSubmit"
            :disabled="
              ($refs.dialogUploadProfileImage &&
                $refs.dialogUploadProfileImage.isCrop) ||
                !validateForm
            "
            :color="AISEA_COLOR.BLUE"
            >保存</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
import moment from "moment-timezone";
import Datepicker from "vuejs-datepicker";
import DatepickerMixin from "@/mixins/DatepickerMixin";
import { storage } from "@/firebase/firebaseConfig";
import EmbeddedUploadProfileImage from "./EmbeddedUploadProfileImage";
import AffiliatedCompanyInput from "./form/AffiliatedCompanyInput.vue";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseCrewApi = AiseaApiFactory.get("enterpriseCrew");

import { createNamespacedHelpers, mapState } from "vuex";
const { mapState: mapCrewListState } = createNamespacedHelpers("crewList");
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import { isPermanentEmployee as checkIsPermanentEmployee } from "../../crew-settings/constants/EmploymentStatus.js";

export default {
  name: "CrewEdit",
  components: {
    vSelect,
    Datepicker,
    EmbeddedUploadProfileImage,
    AffiliatedCompanyInput,
  },
  mixins: [DatepickerMixin, DeviceInfoMixin, ColorMixin],
  props: {
    inputParam: Object,
    activeSidebarCrew: Boolean,
    fromPage: String,
  },
  data() {
    return {
      avatar: null,
      avatarText: "",
      localData: {},
      continueFlg: false,
      disabledDates: {
        from: moment()
          .local()
          .startOf("day")
          .toDate(),
      },
      disabledStartYear: false,
    };
  },
  computed: {
    ...mapCrewListState({
      laborTemplates: state => state.laborTemplates,
    }),
    ...mapState("auth", {
      user: state => state.user,
    }),
    companyName() {
      return this.user && this.user.name ? this.user.name : "";
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.localData.name &&
        this.localData.name_kana &&
        this.getAffiliatedCompaniesError() === ""
      );
    },
  },
  watch: {
    activeSidebarCrew(val) {
      if (val) {
        this.initLocalData();
        this.$validator.reset();
      }
    },
  },
  methods: {
    initLocalData() {
      this.avatar = null;
      this.avatarText = "";

      if (this.inputParam.id) {
        this.localData = JSON.parse(JSON.stringify(this.inputParam));
        console.debug("### localData", this.localData);

        // affiliated_companiesが存在しない場合は空配列を設定
        if (!this.localData.affiliated_companies) {
          Vue.set(this.localData, "affiliated_companies", []);
        }

        // 社員区分が「社員」の場合、会社名を設定
        if (
          this.localData.affiliated_companies &&
          this.localData.affiliated_companies.length > 0
        ) {
          this.localData.affiliated_companies = this.localData.affiliated_companies.map(
            company => {
              if (checkIsPermanentEmployee(company.status)) {
                return {
                  ...company,
                  name: this.companyName || company.name,
                };
              }
              return company;
            }
          );
        }

        this.localData.union_member = this.localData.union_member
          ? "組合員"
          : "-";

        if (this.inputParam.picture) {
          storage
            .child(this.inputParam.picture.thumbnail_path)
            .getDownloadURL()
            .then(response => {
              this.avatar = response;
            });
        }
      } else {
        this.continueFlg = this.inputParam.continueFlg;
        // 新規作成時は空のaffiliated_companiesを設定
        Vue.set(this.localData, "affiliated_companies", [
          {
            start_date: null,
            status: null,
            name: "",
          },
        ]);
      }
    },

    getAffiliatedCompaniesError() {
      if (this.errors.has("affiliated_companies")) {
        return this.errors.first("affiliated_companies");
      }

      // CrewBasicInfoForm.vueと同じバリデーションロジックを適用
      if (
        !this.localData.affiliated_companies ||
        this.localData.affiliated_companies.length === 0 ||
        this.localData.affiliated_companies.every(
          item =>
            (!item.start_date || item.start_date === "") &&
            (!item.status || item.status === "") &&
            (!item.name || item.name.trim() === "")
        )
      ) {
        return "社員区分 / 所属企業は必須項目です";
      } else {
        // 各項目のバリデーション
        const usedStartDates = new Set();
        let hasValidRow = false; // 有効な行（空でない行）が存在するか
        for (let i = 0; i < this.localData.affiliated_companies.length; i++) {
          const item = this.localData.affiliated_companies[i];
          // 空の行が1つでもあればエラーを返す
          if (
            (!item.start_date || item.start_date === "") &&
            (!item.status || item.status === "") &&
            (!item.name || item.name.trim() === "")
          ) {
            return "社員区分 / 所属企業は必須項目です";
          }
          hasValidRow = true; // 有効な行が見つかった
          if (!item.start_date || item.start_date === "") {
            return "開始日を入力してください";
          }
          // 開始日の重複チェック
          if (usedStartDates.has(item.start_date)) {
            return "開始日が重複しています";
          }
          usedStartDates.add(item.start_date);
          if (!item.status || item.status === "") {
            return "社員区分を選択してください";
          }
          if (!item.name || item.name.trim() === "") {
            return "所属企業を入力してください";
          }
        }
        // 有効な行が1つもなかった場合（全て空の行だった場合）
        if (!hasValidRow) {
          return "社員区分 / 所属企業は必須項目です";
        }
      }

      return "";
    },

    toggleCollapse() {
      this.$el.querySelector("#collapse-header-work-area").click();
    },

    showDialogUpload() {
      this.$refs.dialogUploadProfileImage.show();
    },

    async onImageUploaded(pictureData) {
      this.localData.picture = pictureData.data;
      this.toggleCollapse();
      try {
        // affiliated_companiesからend_dateがnullの場合は除外
        // 社員区分が「社員」の場合は所属企業名をnullにする
        const affiliatedCompanies = (
          this.inputParam.affiliated_companies || []
        ).map(company => {
          const companyData = { ...company };
          // end_dateがnullまたは空の場合はプロパティ自体を削除
          if (
            companyData.end_date === null ||
            companyData.end_date === undefined ||
            companyData.end_date === ""
          ) {
            delete companyData.end_date;
          }
          // 社員区分が「社員」の場合は所属企業名をnullにする
          if (checkIsPermanentEmployee(companyData.status)) {
            companyData.name = null;
          }
          return companyData;
        });

        let payload = {
          name: this.inputParam.name,
          name_kana: this.inputParam.name_kana,
          affiliated_companies: affiliatedCompanies,
          joining_date: this.inputParam.joining_date,
          retirement_date: this.inputParam.retirement_date,
          employee_number: this.inputParam.employee_number,
          union_member: this.inputParam.union_member,
          email_address: this.inputParam.email_address,
          phone_number: this.inputParam.phone_number,
          birth_date: this.inputParam.birth_date
            ? moment(this.inputParam.birth_date).format("YYYY-MM-DD")
            : "",
          postal_code: this.inputParam.postal_code,
          prefecture: this.inputParam.prefecture,
          address: this.inputParam.address,
          memo: this.inputParam.memo,
          crew_available_roles: this.inputParam.crew_available_roles,
          picture: this.localData.picture.id,
        };

        const res = await enterpriseCrewApi.update(this.inputParam.id, payload);
        if (res.status) {
          this.$vs.notify({
            title: `船員基本情報設定`,
            text: `${this.localData.name}の画像を更新しました。`,
            color: "success",
            icon: "done",
          });
          this.avatar = null;
          storage
            .child(this.localData.picture.thumbnail_path)
            .getDownloadURL()
            .then(response => {
              this.avatar = response;
            });
          this.$emit("reloadList");
        } else {
          this.$vs.notify({
            title: `船員基本情報設定`,
            text: `${this.localData.name}の画像を更新できませんでした。`,
            color: "danger",
            icon: "done",
          });
        }
      } catch (e) {
        this.$vs.notify({
          title: `船員基本情報設定`,
          text: `${this.localData.name}の画像を更新できませんでした。`,
          color: "danger",
          icon: "done",
        });
      }
      this.$el.querySelector("#collapse-header-avatar-area").click();
    },

    onImageUploadCancel() {
      this.$el.querySelector("#collapse-header-avatar-area").click();
    },

    scrollEndAdjust() {
      setTimeout(() => {
        this.$refs.crewEditForm.scrollTop = this.$refs.crewEditForm.scrollHeight;
      }, 200);
    },

    onCancel() {
      this.localData = {};
      this.$nextTick(() => {
        this.$emit("close");
      });
    },
    async onSubmit() {
      this.checkValidate = await this.$validator.validateAll();
      if (!this.checkValidate) {
        return false;
      }

      const unionMemberBoolean = this.localData.union_member === "組合員";

      // affiliated_companiesからend_dateがnullの場合は除外
      // 社員区分が「社員」の場合は所属企業名をnullにする
      const affiliatedCompanies = (
        this.localData.affiliated_companies || []
      ).map(company => {
        const companyData = { ...company };
        // end_dateがnullまたは空の場合はプロパティ自体を削除
        if (
          companyData.end_date === null ||
          companyData.end_date === undefined ||
          companyData.end_date === ""
        ) {
          delete companyData.end_date;
        }
        // 社員区分が「社員」の場合は所属企業名をnullにする
        if (checkIsPermanentEmployee(companyData.status)) {
          companyData.name = null;
        }
        return companyData;
      });

      let payload = {
        name: this.localData.name,
        name_kana: this.localData.name_kana,
        affiliated_companies: affiliatedCompanies,
        joining_date: "",
        retirement_date: "",
        employee_number: this.localData.employee_number || "",
        union_member: unionMemberBoolean,
        email_address: this.localData.email_address || "",
        phone_number: this.localData.phone_number || "",
        birth_date: this.localData.birth_date
          ? moment(this.localData.birth_date).format("YYYY-MM-DD")
          : "",
        postal_code: "",
        prefecture: "",
        address: "",
        memo: "",
        crew_available_roles: [],
      };

      if (this.inputParam.id) {
        // 更新APIをコール

        console.debug("### 更新API payload", this.inputParam.id, payload);

        try {
          this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
          const res = await enterpriseCrewApi.update(
            this.inputParam.id,
            payload
          );
          if (res.status) {
            this.$vs.notify({
              title: `船員基本情報編集`,
              text: `${this.localData.name}の登録内容を変更しました`,
              color: "success",
              icon: "done",
            });
          } else {
            Vue.$log.warn(
              "error at enterpriseCrewApi.update() ",
              this.inputParam.id,
              payload,
              res
            );
            this.$vs.notify({
              title: `船員基本情報編集`,
              text: `${this.localData.name}の登録内容を変更できませんでした`,
              color: "warning",
              icon: "done",
            });
          }
          this.$vs.loading.close();
        } catch (e) {
          this.$vs.loading.close();
          Vue.$log.warn(
            "error at enterpriseCrewApi.update() ",
            this.inputParam.id,
            payload,
            e
          );
          this.$vs.notify({
            title: `船員基本情報編集`,
            text: `${this.localData.name}の登録内容を変更できませんでした`,
            color: "warning",
            icon: "done",
          });
        }
      } else {
        // 登録APIをコール

        console.debug("### 登録API payload", payload);
        try {
          this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
          const res = await enterpriseCrewApi.add(payload);
          if (res.status) {
            this.localData.id = res.data.id;

            // 船員登録自体は成功したので成功メッセージを表示
            this.$vs.notify({
              title: `船員基本情報登録`,
              text: `${this.localData.name}の船員登録が完了しました`,
              color: "success",
              icon: "done",
            });
          } else {
            Vue.$log.warn("error at enterpriseCrewApi.add() ", payload, res);
            this.$vs.notify({
              title: `船員基本情報登録`,
              text: `${this.localData.name}の船員登録ができませんでした`,
              color: "warning",
              icon: "done",
            });
          }
          this.$vs.loading.close();
        } catch (e) {
          this.$vs.loading.close();
          Vue.$log.warn("error at enterpriseCrewApi.add() ", payload, e);
          this.$vs.notify({
            title: `船員基本情報登録`,
            text: `${this.localData.name}の船員登録ができませんでした`,
            color: "warning",
            icon: "done",
          });
        }
      }

      this.$emit("updatedId", this.localData.id);
      this.localData = {};

      this.$nextTick(() => {
        this.$emit("reloadList");
        this.$emit("close", this.continueFlg);
      });
    },
  },
  created() {
    this.initLocalData();
  },
  mounted() {
    // サイドバーの幅をコンテンツに合わせて広げる
    this.$nextTick(() => {
      const sidebarDialog = this.$el.closest(".vs-dialog");
      if (sidebarDialog) {
        sidebarDialog.style.maxWidth = "850px";
        sidebarDialog.style.width = "850px";
      }
    });
  },
  beforeDestroy() {
    // サイドバーの幅を元に戻す
    const sidebarDialog = this.$el.closest(".vs-dialog");
    if (sidebarDialog) {
      sidebarDialog.style.maxWidth = "";
      sidebarDialog.style.width = "";
    }
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

.crew-edit {
  min-width: 100%;
  width: 100%;

  label {
    font-family: $aisea-font-family;
    font-size: 14px;
    font-weight: 600;
  }

  .required label {
    &:after {
      content: " *";
      font-size: 0.8rem;
      color: rgba(var(--vs-danger), 1);
    }
  }

  .vs-inputx {
    color: $aisea-dark-gray !important;
    font-family: $aisea-font-family;
    font-size: 16px !important;
    font-weight: 400;
  }
  .vs-input--placeholder {
    color: $aisea-slightly-gray !important;
  }

  .v-select {
    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    input {
      height: 2rem;
    }
  }

  .crew-edit-form-row {
    flex-direction: column;
    margin: 1rem 0;
    padding-right: 8px;
  }

  .vs__search::placeholder {
    color: $aisea-light-gray;
  }

  .vdp-datepicker input {
    padding-left: 2.4rem;
    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;
  }

  .vs-collapse-item--header {
    padding: 0;
  }
  .vs-collapse-item {
    border-bottom: none;
  }

  .vdp-datepicker__calendar {
    .selected {
      background: $aisea-blue !important;
    }
  }
}
</style>
